import React from "react";
import "./Socmed.scss";
export const Socmed = () => {
  return (
    <div className="SocMed__Icons">
      {/* <div className="icon Discord"> 
        <a
          href="https://discord.gg/6UK5rnFtWk"
          className="icon"
          target="_blank"
          rel="noreferrer"
        >
          <svg
            width="78"
            height="78"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M26.07 20.8912C24.5388 20.8912 23.804 22.6688 23.804 23.4916C23.804 24.1692 24.5388 26.092 26.07 26.092C27.6012 26.092 28.5032 25.0228 28.5032 23.4916C28.5032 21.9604 27.6012 20.8912 26.07 20.8912Z"
              fill="white"
            />
            <path
              d="M22 0C9.8516 0 0 9.8516 0 22C0 34.1484 9.8516 44 22 44C34.1484 44 44 34.1484 44 22C44 9.8516 34.1484 0 22 0ZM35.6048 28.2964C33.6336 31.108 29.4756 31.9572 28.3492 31.68C27.2228 30.272 27.0556 29.8804 27.0556 29.8804C27.0556 29.8804 30.162 28.5736 30.9452 27.1436C29.2732 28.028 27.7024 29.5768 22.6336 29.744H21.2828C16.214 29.5768 14.6872 28.028 13.0152 27.1436C13.794 28.578 16.94 29.8716 16.94 29.8716C16.94 29.8716 16.7772 30.2676 15.6508 31.6756C14.5288 31.9572 10.3664 31.108 8.3996 28.2964C7.8936 22.11 11.2156 15.6288 11.2156 15.6288C11.638 13.618 18.0048 11.572 18.5812 12.5136C18.3832 13.09 15.4088 13.2176 12.6104 15.5672C15.2504 13.8556 19.3336 13.3672 21.3312 13.2308L21.9824 13.1956H21.9956L22.66 13.2308C24.6576 13.3672 28.7452 13.8556 31.3852 15.5672C28.5868 13.2176 25.6168 13.09 25.4188 12.5136C25.9952 11.572 32.3664 13.618 32.7888 15.6288C32.7844 15.6244 36.1108 22.1056 35.6048 28.2964Z"
              fill="white"
            />
            <path
              d="M17.7936 20.8912C16.2624 20.8912 15.3604 21.9604 15.3604 23.4916C15.3604 25.0228 16.2624 26.092 17.7936 26.092C19.3248 26.092 20.0596 24.1692 20.0596 23.4916C20.0552 22.6644 19.3248 20.8912 17.7936 20.8912Z"
              fill="white"
            />
          </svg>
        </a>
      </div>*/}

      <div className="icon Insta">
        <a
          href="https://www.instagram.com/martleystrategy/"
          className="icon"
          target="_blank"
          rel="noreferrer"
        >
          <svg
            width="78"
            height="78"
            viewBox="0 0 78 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M48.126 20.3385H29.874C24.6714 20.3385 20.4282 24.5906 20.4282 29.8041V48.0867C20.4282 53.3002 24.6714 57.5524 29.874 57.5524H48.126C53.3286 57.5524 57.5718 53.3002 57.5718 48.0867V29.8041C57.564 24.5906 53.3286 20.3385 48.126 20.3385ZM39.1872 50.2284C32.9706 50.2284 27.9318 45.179 27.9318 38.9493C27.9318 32.7196 32.9706 27.6702 39.1872 27.6702C45.4038 27.6702 50.4426 32.7196 50.4426 38.9493C50.4426 45.179 45.4038 50.2284 39.1872 50.2284ZM51.1134 29.5931C49.6158 29.5931 48.4224 28.3894 48.4224 26.9199C48.4224 25.4191 49.6236 24.2232 51.1134 24.2232C52.5798 24.2232 53.781 25.4269 53.781 26.9199C53.781 28.3894 52.5798 29.5931 51.1134 29.5931ZM39.1872 31.727C35.2092 31.727 31.9878 34.963 31.9878 38.9415C31.9878 42.9201 35.217 46.1873 39.1872 46.1873C43.1574 46.1873 46.3866 42.9279 46.3866 38.9415C46.3866 34.9551 43.1652 31.727 39.1872 31.727ZM48.126 20.3385H29.874C24.6714 20.3385 20.4282 24.5906 20.4282 29.8041V48.0867C20.4282 53.3002 24.6714 57.5524 29.874 57.5524H48.126C53.3286 57.5524 57.5718 53.3002 57.5718 48.0867V29.8041C57.564 24.5906 53.3286 20.3385 48.126 20.3385ZM39.1872 50.2284C32.9706 50.2284 27.9318 45.179 27.9318 38.9493C27.9318 32.7196 32.9706 27.6702 39.1872 27.6702C45.4038 27.6702 50.4426 32.7196 50.4426 38.9493C50.4426 45.179 45.4038 50.2284 39.1872 50.2284ZM51.1134 29.5931C49.6158 29.5931 48.4224 28.3894 48.4224 26.9199C48.4224 25.4191 49.6236 24.2232 51.1134 24.2232C52.5798 24.2232 53.781 25.4269 53.781 26.9199C53.781 28.3894 52.5798 29.5931 51.1134 29.5931ZM39.1872 31.727C35.2092 31.727 31.9878 34.963 31.9878 38.9415C31.9878 42.9201 35.217 46.1873 39.1872 46.1873C43.1574 46.1873 46.3866 42.9279 46.3866 38.9415C46.3866 34.9551 43.1652 31.727 39.1872 31.727ZM39 -0.0780029C17.4486 -0.0780029 0 17.4307 0 39.004C0 60.6008 17.4486 78.0861 39 78.0861C60.5514 78.0861 78 60.6008 78 39.004C78 17.4307 60.5514 -0.0780029 39 -0.0780029ZM61.8618 48.0867C61.8618 55.6764 55.6998 61.8514 48.126 61.8514H29.874C22.3002 61.8514 16.1382 55.6764 16.1382 48.0867V29.8041C16.1382 22.2144 22.3002 16.0394 29.874 16.0394H48.126C55.6998 16.0394 61.8618 22.2144 61.8618 29.8041V48.0867ZM48.126 20.3385H29.874C24.6714 20.3385 20.4282 24.5906 20.4282 29.8041V48.0867C20.4282 53.3002 24.6714 57.5524 29.874 57.5524H48.126C53.3286 57.5524 57.5718 53.3002 57.5718 48.0867V29.8041C57.564 24.5906 53.3286 20.3385 48.126 20.3385ZM39.1872 50.2284C32.9706 50.2284 27.9318 45.179 27.9318 38.9493C27.9318 32.7196 32.9706 27.6702 39.1872 27.6702C45.4038 27.6702 50.4426 32.7196 50.4426 38.9493C50.4426 45.179 45.4038 50.2284 39.1872 50.2284ZM51.1134 29.5931C49.6158 29.5931 48.4224 28.3894 48.4224 26.9199C48.4224 25.4191 49.6236 24.2232 51.1134 24.2232C52.5798 24.2232 53.781 25.4269 53.781 26.9199C53.781 28.3894 52.5798 29.5931 51.1134 29.5931ZM39.1872 31.727C35.2092 31.727 31.9878 34.963 31.9878 38.9415C31.9878 42.9201 35.217 46.1873 39.1872 46.1873C43.1574 46.1873 46.3866 42.9279 46.3866 38.9415C46.3866 34.9551 43.1652 31.727 39.1872 31.727Z"
              fill="white"
            />
          </svg>
        </a>
      </div>

      <div className="icon Yt">
        <a
          href="https://www.youtube.com/channel/UC7Gove13Ftsbs3gaLXbp8PA"
          className="icon"
          target="_blank"
          rel="noreferrer"
        >
          <svg
            width="78"
            height="78"
            viewBox="0 0 78 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M45.8016 39.7176L35.0532 45.0528C34.6242 45.2634 33.2124 44.9748 33.2124 44.4912V33.5868C33.2124 33.1032 34.6554 32.7834 35.0766 33.0252L45.3492 38.6256C45.7782 38.8674 46.2306 39.507 45.8016 39.7176ZM78 39C78 60.528 60.5514 78 39 78C17.4486 78 0 60.528 0 39C0 17.4486 17.4486 0 39 0C60.5514 0 78 17.4486 78 39ZM59.8884 33.3216C59.8884 28.1424 55.6998 23.9616 50.5284 23.9616H26.5668C21.3954 23.9616 17.2068 28.1502 17.2068 33.3216V44.4756C17.2068 49.647 21.3954 53.8356 26.5668 53.8356H50.5206C55.692 53.8356 59.8806 49.647 59.8806 44.4756V33.3216H59.8884Z"
              fill="white"
            />
          </svg>
        </a>
      </div>
      <div className="icon LinkedIn">
        <a
          href="https://www.linkedin.com/company/martleystrategy"
          className="icon"
          target="_blank"
          rel="noreferrer"
        >
          <svg
            width="78"
            height="78"
            viewBox="0 0 1000 1000"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M500,0C224,0,0,224,0,500c0,276.3,224,500,500,500c276.3,0,500-223.7,500-500C1000,224,776.3,0,500,0z M387.1,718.2h-96.8V407h96.8V718.2z M338.9,364.6c-31.1,0-56.4-25.3-56.4-56.1c0-31.1,25.3-56.1,56.4-56.1 c30.8,0,55.7,25,55.7,56.1C394.7,339.3,369.7,364.6,338.9,364.6z M749.3,718.2h-96.4V566.7c0-35.9-0.7-82.4-50.3-82.4 c-50.3,0-58.1,39.3-58.1,80v153.9h-96.8V407h93v42.4h1c13-24.3,44.5-50.3,91.7-50.3c97.8,0,115.9,64.6,115.9,148.4V718.2z"
              fill="#FFFFFF"
            />
          </svg>
        </a>
      </div>
      <div className="icon G">
        <a
          href="https://g.page/martleystrategy?we"
          className="icon"
          target="_blank"
          rel="noreferrer"
        >
          <svg
            width="78"
            height="78"
            viewBox="0 0 78 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M39.0234 -0.0781708C17.4408 -0.0781708 0 17.3915 0 39.0195C0 60.5615 17.4408 78.0859 39.0234 78.0859C60.5592 78.0859 78 60.5693 78 39.0273C78 17.3915 60.5592 -0.0781708 39.0234 -0.0781708ZM52.6734 54.3006C49.2102 57.5757 44.5848 59.5767 39.4134 59.5767C31.629 59.5767 24.6792 55.051 21.2082 48.4305C19.7262 45.6009 18.876 42.3962 18.876 38.9961C18.876 35.6975 19.6794 32.5788 21.0756 29.8118C24.4998 23.0584 31.5276 18.4155 39.4056 18.4155C44.694 18.4155 49.4052 20.5103 52.8996 23.9182L47.307 29.6007C45.2556 27.8186 42.6036 26.7556 39.6552 26.7556C34.359 26.7556 29.6946 30.2182 27.9396 35.0566C27.4638 36.3776 27.1986 37.7923 27.1986 39.2696C27.1986 40.6219 27.417 41.9272 27.8226 43.1466C29.4762 48.1647 34.2342 51.7837 39.6552 51.7837C42.2838 51.7837 44.6784 50.9239 46.6206 49.4779C48.7578 47.8833 50.3568 45.5853 51.1134 42.8886H39.4134V35.1035H58.7652C58.9914 36.3619 59.1162 37.6673 59.1162 38.9961C59.1162 45.0772 56.6592 50.5331 52.6734 54.3006Z"
              fill="white"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};
